import { toast } from "react-toastify";
import { NOTAS_CARGO_API } from "../views/MainLayout/components/shared/services/nota_cargo";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialNotas = []

export const notasCargoReducer = (state = initialNotas, action) => {
    switch(action.type){
        case "notas_cargo/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchNotasCargo = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await NOTAS_CARGO_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'notas_cargo/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}
